import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import {
  Opts,
  Model,
  QueryParams,
  PagedResponse,
  PatchWithMeta,
  ValidatedResponse,
} from "@ofqual/portal-core/core/types";
import { paramsToSearchString } from "@ofqual/portal-core/core/utils/urlHelper";

import { PagedResponseTo } from "@ofqual/portal-core/core/utils/pagedResponseHelpers";
import { Unit, fromApiModel } from "../domain/Unit";
import { getValidationError } from "@ofqual/portal-core/core/utils/validationHelper";

export class UnitService extends BaseRemoteService {
  public async get(id: string, opts: Opts): Promise<Unit> {
    const url = `${this.apiRoot}/units/${id}`;
    const response = await super.getRequest<Model>(url, opts);
    return fromApiModel(response);
  }

  public async search(
    params: QueryParams,
    opts: Opts
  ): Promise<PagedResponse<Unit>> {
    const url = `${this.apiRoot}/units/${paramsToSearchString(params)}`;
    const response = await super.getRequest<PagedResponse<Model>>(url, opts);
    return PagedResponseTo<Unit>(response, fromApiModel);
  }

  public async update(
    id: string,
    patchWithMeta: PatchWithMeta<Unit>,
    opts: Opts
  ): Promise<ValidatedResponse<Unit>> {
    const url = `${this.apiRoot}/units/${id}`;
    try {
      const response = await this.patchRequest<Unit, PatchWithMeta<Unit>>(
        url,
        patchWithMeta,
        opts
      );
      return {
        isValid: true,
        data: fromApiModel(response),
      };
    } catch (err) {
      const validationError = getValidationError(err);
      if (validationError.isValidationError) {
        return { isValid: false, error: validationError.error };
      }
      throw err;
    }
  }

  public async create(
    item: Unit,
    opts: Opts
  ): Promise<ValidatedResponse<Unit>> {
    const url = `${this.apiRoot}/units`;
    try {
      const response: Unit =  await super.postRequest(
        url,
        item,
        opts
      );
      return {
        isValid: true,
        data: response,
      };
    } catch (err) {
      const validationError = getValidationError(err);
      if (validationError.isValidationError) {
        return { isValid: false, error: validationError.error };
      }
      throw err;
    }
  }
  
}
